import classNames from 'classnames';

import CardDescription from '@/components/CardDescription';
import Icon, { IconTypes } from '@/components/Icon';

import * as styles from './styles.module.scss';

interface ItemContainerProps {
    classname?: string;
    imagePath?: string;
    backgroundIconType?: IconTypes;
    backgroundImagePath: string;
    textBackgroundImagePath: string;
    title: string;
    subtitle?: string;
    highlightImagePath?: string;
    isSelected?: boolean;
    onSelected?: () => void;
    imageAlt?: string;
    interactable?: boolean;
    hasBorder?: boolean;
    hideDescription?: boolean;
}

export default function ItemContainer({
    classname,
    imagePath,
    backgroundImagePath,
    textBackgroundImagePath,
    highlightImagePath,
    title,
    subtitle,
    isSelected,
    onSelected,
    imageAlt,
    interactable,
    hasBorder = true,
    backgroundIconType,
    hideDescription,
}: ItemContainerProps) {
    const highlightImageStyle = highlightImagePath ? { backgroundImage: `url(${highlightImagePath})` } : {};

    return (
        <div className={classNames(styles.ItemContainer, classname)}>
            <button
                className={classNames(styles.ItemContainer__Button, {
                    [styles['ItemContainer__Button--interactable']]: interactable,
                })}
                onClick={() => onSelected && onSelected()}
                disabled={!interactable}
                aria-selected={isSelected}
            >
                <div className={styles.ItemContainer__ImageArea}>
                    <div
                        className={classNames(styles.ItemContainer__BackgroundContainer, {
                            [styles.noBackgroundImage]: !backgroundImagePath,
                        })}
                        style={backgroundImagePath ? { backgroundImage: `url("${backgroundImagePath}")` } : {}}
                    >
                        {backgroundIconType && (
                            <Icon className={styles.ItemContainer__BackgroundIcon} type={backgroundIconType} />
                        )}
                    </div>
                    {hasBorder && <div className={styles.ItemContainer__Border}></div>}
                    <div
                        className={styles.ItemContainer__Image}
                        style={imagePath ? { backgroundImage: `url(${imagePath})` } : {}}
                        role="img"
                        aria-label={imageAlt}
                    />
                </div>
                {!hideDescription && (
                    <CardDescription
                        classname={styles.ItemContainer__Description}
                        title={title}
                        subtitle={subtitle}
                        backgroundImage={textBackgroundImagePath}
                    />
                )}
            </button>
            {highlightImagePath && (
                <div className={styles.ItemContainer__HighlightImage} style={highlightImageStyle}></div>
            )}
        </div>
    );
}
